import Img2019_1 from '../img/jury/data4 2019_1.jpg'
import Img2019_2 from '../img/jury/data4 2019_2.jpg'
import Img2019_3 from '../img/jury/data4 2019_3.jpg'
import Img2020_1 from '../img/jury/data4 2020_1.jpg'
import Img2020_2 from '../img/jury/data4 2020_2.jpg'
import Img2021_1 from '../img/jury/data4 2021_1.jpg'
import Img2021_3 from '../img/jury/photo_2024-05-09 22.53.48.jpeg'
import Img2022_1 from '../img/jury/data4 2022_1.jpg'
import Img2022_2 from '../img/jury/data4 2022_2.jpg'
import Img2023_1 from '../img/jury/data4 2023_1.jpg'
import Img2023_2 from '../img/jury/data4 2023_2.jpg'

const data4 = [
    {
      year: 2019,
      items: [
        {
          name: 'НАТАЛЬЯ ЕГОРОВА',
          country: 'Россия',
          image: Img2019_1,
          text1: 'Мастер перманентного макияжа',
          text2: 'Преподаватель учебного центра косметологии с 8-ми летним стажем',
          text3: 'Спикер международной ассамблеи',
          text4: 'Автор и руководитель проекта "Реконструкция кожи воздействием плазменной дуги в сочетании с сухой иглой"',
          text5: 'Стаж работы более 10 лет',
        },
        {
            name: 'НАТАЛЬЯ ДОЛГОПОЛОВА',
            country: 'Израиль',
          image: Img2019_2,
          text1: 'Cертифицированный тренер, преподаватель международного уровня, основатель и руководитель Академии перманентного макияжа (Израиль)',
          text2: 'Специалист по удалению татуировок с помощью лазера и ремувера',
          text3: 'Создатель книги "Колористика в перманентном макияже"',
          text4: 'Докладчик международных конгрессов и конференций, организатор международных конгрессов и мастер-классов в Израиле',
          text5: 'Стаж работы более 15 лет',
        },
        {
            name: 'ЕВГЕНИЯ БРЮХОВЕЦКАЯ',
            country: 'Украина',
            image: Img2019_3,
            text1: 'Чемпион мира  в командной номинации по перманентному макияжу ("IBF" 2018г.), топ-мастер Украины (2017г.)',
            text2: 'Основатель и ведущий мастер-преподаватель школ-студий перманентного макияжа "Vobrazi"',
            text3: ' Участник международных выставок, спикер конференций и форумов по перманентному макияжу',
            text4: 'Организатор международного фестиваля по перманентному макияжу "Free PMU"',
            text5: 'Специалист по лазерному удалению тату и татуажа, косметолог',
        },
      ],
    },
    {
        year: 2020,
        items: [
          {
            name: 'НАТАЛЬЯ ШИРОКОВА',
            country: 'Беларусь',
          image: Img2020_1,
          text1: 'Визажист-бровист, технолог Elan в Белорусии, cудья чемпионатов России',
          text2: 'Лучший мастер России 2016 года',
          text3: 'Почетный член Международной ассоциации бровистов',
          text4: 'Судья международных чемпионатов',
          text5: 'Стаж работы более 10 лет',
          },
          {
            name: 'ЮЛИЯ МИХАЙЛОВА',
            country: 'Украина',
            image: Img2020_2,
            text1: 'Основатель и преподаватель студии "Triumf school"',
            text2: 'Призер Международного Чемпионата "Невские Берега": золото в творческом двоеборье',
            text3: 'Призер чемпионата художественного оформления, восстановления и микроблейдинга бровей "B. E. Brow Expert"',
            text4: 'Призер Международного чемпионата по визажу IBF в номинации "Fashion wedding make-up"',
            text5: 'Постоянный участник мастер-классов, семинаров и конгрессов',
          },
          {
            name: 'ЕВГЕНИЯ БРЮХОВЕЦКАЯ',
            country: 'Украина',
            image: Img2019_3,
            text1: 'Чемпион мира  в командной номинации по перманентному макияжу ("IBF" 2018г.), топ-мастер Украины (2017г.)',
            text2: 'Основатель и ведущий мастер-преподаватель школ-студий перманентного макияжа "Vobrazi"',
            text3: ' Участник международных выставок, спикер конференций и форумов по перманентному макияжу',
            text4: 'Организатор международного фестиваля по перманентному макияжу "Free PMU"',
            text5: 'Специалист по лазерному удалению тату и татуажа, косметолог',
          },
        ],
      },
      {
        year: 2021,
        items: [
          {
            name: 'НАТАЛЬЯ МАЗУР',
            country: 'Украина',
          image: Img2021_1,
          text1: 'Международный инструктор-преподаватель KODI PROFESSIONAL по направлениям "Перманентный макияж" и "Лазерные технологии"',
          text2: 'Косметолог с медицинским образованием',
          text3: 'Визажист-стилист, бровист',
          text4: 'Топ-5 лучших мастеров мира по версии WBF 2019 (Австрия)',
          text5: 'Участник международных и мировых чемпионатов по перманентному макияжу, визажу',
        },
          {
            name: 'Дарья Махиня',
            country: 'Украина',
            image: Img2021_3,
            text1: 'Спикер на Международных конгрессах и конференциях',
            text2: 'Победитель Международного конкурса «Звезды Красоты» 2020',
            text3: 'Победитель Международной премии «Олимп Красоты» в номинации «Инновации в процедурах» 2019 год',
            text4: 'Судья украинских и международных конкурсов по перманентному макияжу',
            text5: 'Стаж работы более 10 лет',
          },
          {
            name: 'НАТАЛЬЯ ДОЛГОПОЛОВА',
            country: 'Израиль',
          image: Img2019_2,
          text1: 'Cертифицированный тренер, преподаватель международного уровня, основатель и руководитель Академии перманентного макияжа (Израиль)',
          text2: 'Специалист по удалению татуировок с помощью лазера и ремувера',
          text3: 'Создатель книги "Колористика в перманентном макияже"',
          text4: 'Докладчик международных конгрессов и конференций, организатор международных конгрессов и мастер-классов в Израиле',
          text5: 'Стаж работы более 15 лет',
          },
        ],
      },
      {
        year: 2022,
        items: [
          {
            name: 'ЕЛЕНА ИВАНОВА',
            country: 'Россия',
            image: Img2022_1,
            text1: 'Мастер-преподаватель, технолог с опытом работы 12 лет',
            text2: 'Автор и разработчик техники "Natural look"',
            text3: 'Судья российских и международных конкурсов по наращиванию ресниц и оформлению бровей',
            text4: 'Официальный представитель KODI PROFESSIONAL в Санкт-Петербурге',
            text5: 'Стаж работы более 15 лет',
          },
          {
            name: 'ВАСИЛЬЕВ АЛЕКСЕЙ',
            country: 'Украина',
            image: Img2022_2,
            text1: 'Визажист, мастер международного класса',
            text2: 'Член национальной сборной Украины по макияжу',
            text3: 'Чемпион Украины по макияжу 2016 , бронзовый призёр OMC Europe Cup 2016',
            text4: 'Призёр OMC Hairworld 2017',
            text5: 'Сертифицированный судья и тренер ABC',
          },
          {
            name: 'ЮЛИЯ МИХАЙЛОВА',
            country: 'Украина',
            image: Img2020_2,
            text1: 'Основатель и преподаватель студии "Triumf school"',
            text2: 'Призер Международного Чемпионата "Невские Берега": золото в творческом двоеборье',
            text3: 'Призер чемпионата художественного оформления, восстановления и микроблейдинга бровей "B. E. Brow Expert"',
            text4: 'Призер Международного чемпионата по визажу IBF в номинации "Fashion wedding make-up"',
            text5: 'Постоянный участник мастер-классов, семинаров и конгрессов',
          },
        ],
      },
      {
        year: 2023,
        items: [
          {
            name: 'ИРИНА ЧЕРНЫШ',
            country: 'Украина',
          image: Img2023_1,
          text1: 'Мастер международного уровня, член национальной сборной по макияжу',
          text2: 'Золотой призёр Чемпионата Европы в номинации Подиумный макияж 2012',
          text3: 'Свадебный макияж, визажист-гримёр телеканалов ZIK, НТА',
          text4: 'Судья украинских и международных чемпионатов по макияжу, по наращиванию ресниц',
          text5: 'Мастер-лэшмейкер, мастер-бровист, технолог-преподаватель компании KODI professional',
          },
          {
            name: 'НАТАЛЬЯ КОНДРАТЧУК',
            country: 'Украина',
            image: Img2023_2,
            text1: 'Визажист-стилист, мастер международного класса, сертифицированный судья Украины по макияжу',
            text2: 'Вице-чемпион Европы OMC EUROPE CUP OPEN 2009, (Греция, Афины)',
            text3: 'Обладатель первенства Paris CUP OPEN 2009 (Франция, Париж)',
            text4: 'Абсолютный чемпион в двоеборье среди мастеров на Международных Олимпийских соревнованиях «Невские берега»',
            text5: 'Многократный призер чемпионатов Украины 2007-2009гг',
          },
          {
            name: 'ЕВГЕНИЯ БРЮХОВЕЦКАЯ',
            country: 'Украина',
            image: Img2019_3,
            text1: 'Чемпион мира  в командной номинации по перманентному макияжу ("IBF" 2018г.), топ-мастер Украины (2017г.)',
            text2: 'Основатель и ведущий мастер-преподаватель школ-студий перманентного макияжа "Vobrazi"',
            text3: ' Участник международных выставок, спикер конференций и форумов по перманентному макияжу',
            text4: 'Организатор международного фестиваля по перманентному макияжу "Free PMU"',
            text5: 'Специалист по лазерному удалению тату и татуажа, косметолог',
          },
        ],
      },
  ];

  export default data4;
